import React from 'react';
import { Save, Trash2, Clock, Calendar } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для отображения сохраненных расчетов
 */
const SavedCalculationsSidebar = ({ 
  savedCalculations, 
  deleteSavedCalculation, 
  loadSavedCalculation 
}) => {
  // Если нет сохраненных расчетов
  if (!savedCalculations || savedCalculations.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Save className="w-5 h-5 mr-2 text-cyan-500" />
          Сохраненные расчеты
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные расчеты дат. Сохраните свой первый расчет, чтобы быстро вернуться к нему позже.
        </p>
        <div className="mt-4 bg-cyan-50 dark:bg-cyan-900/20 p-3 rounded-lg border border-cyan-100 dark:border-cyan-800">
          <div className="text-sm text-cyan-700 dark:text-cyan-300">
            Сохраняйте важные даты и расчеты, чтобы использовать их при планировании.
          </div>
        </div>
      </div>
    );
  }
};

export default SavedCalculationsSidebar;